/* eslint-disable no-console */
import Vue from 'vue';

export const state = {
    token: ''
}

export const mutations = {
    LOGOUT() {

    }
}

export const getters = {
    loggedIn() {
        return !!Vue.prototype.$keycloak.authenticated;
    },
    database(state, getters) {
        return Vue.prototype.$keycloak.token ? getters['accessToken'].database : null;
    },
    username(state, getters) {
        return Vue.prototype.$keycloak.token ? getters['accessToken'].preferred_username : null;
    },
    accessToken() {
        return Vue.prototype.$keycloak.tokenParsed;
    },
    refreshToken() {
        return Vue.prototype.$keycloak.refreshToken;
    },
    authorities(state, getters) {
        return Vue.prototype.$keycloak.token ? getters['accessToken'].authorities : null;
    },
}

export const actions = {
    // Logs in the current user.
    // logIn({ commit, dispatch, getters }, { email, password } = {}) {
    //     if (getters.loggedIn) return dispatch('validate')

    //     return getFirebaseBackend().loginUser(email, password).then((response) => {
    //         const user = response
    //         commit('SET_CURRENT_USER', user)
    //         return user
    //     });
    // },

    // // Logs out the current user.
    // logOut({ commit }) {
    //     // eslint-disable-next-line no-unused-vars
    //     commit('SET_CURRENT_USER', null)
    //     return new Promise((resolve, reject) => {
    //         // eslint-disable-next-line no-unused-vars
    //         getFirebaseBackend().logout().then((response) => {
    //             resolve(true);
    //         }).catch((error) => {
    //             reject(this._handleError(error));
    //         })
    //     });
    // },
    
    logout({ commit }) {
        Vue.prototype.$keycloak.logout({ redirectUri: process.env.VUE_APP_URL })
        commit('LOGOUT')
    }
}